import React from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";

import { Button } from "components/Button";
import { PremiumPlanModalContainer } from "./PremiumPlanModal.styles";
import { Heading } from "style/components/Heading.styles";
import { showPremiumPlanModalSelect } from "Layout/slice/selector";
import { useNavigation } from "utils/navigate";
import { togglePremiumPlanModal } from "Layout/slice";

export const PremiumPlanModal = () => {
  const dispatch = useDispatch();
  const showPremiumPlanModal = useSelector(showPremiumPlanModalSelect) || false;

  const { navigateToPlans } = useNavigation();

  const handleHide = () => {
    dispatch(togglePremiumPlanModal());
  };

  const handleUpgradeClick = () => {
    navigateToPlans();
    handleHide();
  };

  return (
    <PremiumPlanModalContainer show={showPremiumPlanModal} onHide={handleHide}>
      <div className="card-wrapper">
        <Heading>Surmount Premium</Heading>
        <p>
          Connect & manage an unlimited number of broker accounts. Place manual
          trades across all your accounts. Automate your accounts. Deploy up to
          5 automation strategies per account
        </p>
        <div className="text-center" onClick={handleUpgradeClick}>
          <Button>Get Premium</Button>
        </div>
      </div>

      <div onClick={handleHide} className="dismiss">
        {`i'll stay on free`}
      </div>
    </PremiumPlanModalContainer>
  );
};

PremiumPlanModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
};

PremiumPlanModal.displayName = "PremiumPlanModal";
